import React from "react";
import DashboardLayout from "../../layout/DashboardLayout.js";
import ProfileDetails from "./ProfileDetails.js";
import UserLists from "./UserLists.js";
import { Box } from "@mui/material";
// import { getUserById } from "../../services/userService";


function Profile() {
  // const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <DashboardLayout pageName="Profile">
      <Box sx={{ display: 'flex', py:10, flexDirection: { xs: 'column', sm: 'column', md: 'row' },  gap: 5}}>
        <ProfileDetails />  
        {/* <UserLists /> */}
      </Box>
    </DashboardLayout>
  );
}

export default Profile;